<template>
  <l-layout :layout="['xs12']" bottom-space>
    <div v-if="hasPermission">
      <l-data-table
        :get-data-func="getItems"
        :headers="headers"
        @click:row="goDetails($event.item)"
        clickable
        :filter-items="filter"
        init-sort-by="creationTime"
        ref="dataTable"
        hide-title-search
        :init-pagination="{sortBy: 'creationTime', descending: true}"
      >
        <template slot="title">
          <span class="pl-2 pr-4">单位预约</span>
          <v-radio-group v-if="isAdmin" mandatory row v-model="isSelf">
            <v-radio :value="true" label="我的预约"></v-radio>
            <v-radio :value="false" label="全部预约"></v-radio>
          </v-radio-group>
          <!-- <v-flex>
             <v-textarea  v-model="message" disabled auto-grow rows="1"></v-textarea>
           </v-flex>-->
        </template>
        <template slot="row-action" slot-scope="{item}">
          <td @click.stop class="px-0 mx-0 text-xs-center" v-if="!isSelf">
            <v-btn @click="deleteItem(item)" icon :disabled="item.status==='-1'">
              <v-icon small>$vuetify.icons.delete</v-icon>
            </v-btn>
          </td>
        </template>
      </l-data-table>
      <l-fixed-btn
        @click="goNew"
        icon="$vuetify.icons.add"
      ></l-fixed-btn>
    </div>
    <div v-else>
      {{errMsg}}
    </div>
  </l-layout>
</template>

<script>

import {PERSON_ADMIN_HEADERS, PERSON_ADMIN_ACTION_HEADERS,PERSON_GROUP_ACTION_HEADERS} from '@/consts/reservation'
import {ReservationAuthority} from '../../../object'
import {PERMISSION} from '../../../consts/userAdmin'
import {time} from '../../../ladmin/utils'
export default {
  name: 'PersonOrgReservation',
  props: ['refresh'],
  data: () => ({
    hasPermission:true,
    errMsg:'',
    message:"【调测说明】\n\t目前，单位预约人行功能为调测阶段版本，供校园智慧通行系统各单位管理员使用，支持预约提前5天、通行持续7天、每天100人次以内的需求。系统暂时不要求上传单位预约函件，超限预约需求请联系保卫处线下处理。",
    selected: [],
    isSelf: true,
    isSelfHistory: true,
    floatingButton: false,
    showHistory: false,
    // moreActions: [
    //   {
    //     event: 'delete',
    //     label: '批量删除',
    //     icon: '$vuetify.icons.deleteAll'
    //   },
    // ],
    headers: PERSON_GROUP_ACTION_HEADERS,
   /* headers_self: PERSON_ADMIN_HEADERS,
    headers_all: PERSON_ADMIN_ACTION_HEADERS,*/
    userSelect:[],
    filter: [
      {
        prependIcon: '$vuetify.icons.edit',
        key: 'status',
        value: '{"r_h_status":"1"}',
        label: '是否有效',
        type: 'select',
        layout: ['xs12', 'sm4'],
        items: [
          {
            value: '',
            text: '全部'
          },
          {
            value: '{"r_h_status":"1"}',
            text: '有效'
          },
          {
            value: '{"r_h_status":"-1"}',
            text: '失效'
          }],
      },
      {
        label: '预约提交时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'creationTime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = time.toTimeStamp(v.startDatetime) || 0
            let e = time.toTimeStamp(v.endDatetime) || 9999999999999
            return [s, e]
          }
        }
      },
      {
        label: '预约过期时间',
        layout: 'xs12, sm4',
        type: 'duration',
        key: 'expirationTime',
        value: {},
        range: true,
        f: v => {
          if (!v.startDatetime && !v.endDatetime) {
            return null
          }
          else {
            let s = v.startDatetime + ':00' || 0
            let e = v.endDatetime + ':00' || 9999999999999
            return [s, e]
          }
        }
      },
    ]
  }),
  computed: {
    filterItems () {
      return [
        {
          key: 'creationTime',
          value: '',
          type: 'input'
        }
      ]
    },
    isAdmin () {
      let permission =  this.$store.getters['login/getPermission']
      if(permission.passObjectOrder&&permission.passObjectOrder.admin){
        return true
      }else{
        return false
      }
    }
  },
  watch: {
    isSelf () {
      this.$refs.dataTable.refresh()
    },
    isSelfHistory () {
      this.$refs.dataTableHistory.refresh()
    }
  },
  methods: {
    async getUsers (param) {
      let search = (param === undefined) ? '' : param.target.value + ''
      let pagination = {page: 0, rowsPerPage: 10}
      let searchParam = {
        'searchParam': {
          'loginId': {
            'index': '1',
            'order': 'DESC',
            'operators': [
              {
                'keyword': search,
                'operator': 'LIKE',
                'matchType': 'BOTH'
              }
            ]
          }
        }
      }
      let res = await this.$store.dispatch('reservationConfig/getUsers', {param: searchParam, pagination: pagination})
      if (res.data.status === 1) {
        this.userSelect = res.data.data.content
        console.log(this.userSelect)
      }
      else {
        this.userSelect = []
      }
    },
    getUserInfo(){
      return JSON.parse(sessionStorage.getItem('loginInfo'))
    },
    async getItems ({pagination, sortStack, filterItems, search}) {
      let filter = [...filterItems]
      if(this.isSelf){
        filter.push({
          key:'creator',
          value:this.getUserInfo().id
        })
      }
      let {items,amount} = await this.$store.dispatch('personReservation/getOrgReservations', {
        pagination,
        sortStack,
        filter: filter,
        search: {key: 'name', value: search},
      })
      let res = []
      for (let i in items) {
        let item = items[i]
        let j = JSON.parse(item.obgrp.rhdata) || {}
        let obj = {
          id: item.obgrp.id,
          name: item.obgrp.name,
          platePreview: item.platePreview,
          total: item.totalReg,
          host: item.user.name,
          phone: item.user.mobilePhone,
          creationTime: item.obgrp.creationTime,
          expirationTime: item.obgrp.expirationTime,
          status: j.r_h_status
        }
        //console.log(obj)
        res.push(obj)
      }
      return {items:res,amount:amount}
    },
    async getItemsHistory ({pagination, sortStack, filterItems, search}) {
      return this.$store.dispatch('personReservation/getOrgReservationsHistory', {
        pagination,
        sortStack,
        filter: filterItems,
        search: {key: 'plate', value: search},
        self: this.isSelfHistory
      })
    },
    goDetails (item, isHistory) {
      this.getReservationConfig()
      let selectionString = document.getSelection().toString()
      if (!selectionString) {
        this.$router.push({
          name: 'PersonReservationOrgDetails',
          params: {id: item.id},
          query: {id: item.id, status: item.status},
        })
      }
    },
    goNew () {
      this.$router.push({
        name: 'PersonNewOrgReservation'
      })
    },
    async getReservationConfig () {
      let res = await this.$store.dispatch('personReservationConfig/getReservationConfig', 'order_group')
      //console.log(res.data.data)
      if (res.data.status === 1) {
        let object = new ReservationAuthority({
          name: '单位预约',
          maxVehicleAmount: 1000,
          maxStartDay: res.data.data.maxAdvDays,
          maxDurationDay: res.data.data.maxDurDays,
          presetCtrls: res.data.data.presetCtrls
        })
        // console.log(object)
        this.$store.commit('personReservation/setOrgAuth', object)
      }
      else {
        this.hasPermission = false
        this.errMsg = res.data.msg
       //this.$L.alert('error', {message: '查询预约配置失败，原因：' + res.data.msg})
      }
    },
    async deleteItem (item) {
      let {res, close} = await this.$L.confirm({title: '提示', text: '您确定要删除该预约，分组名称：' + item.name})
      if (res) {
        try {
          await this.$store.dispatch('personReservation/deleteGroups', [item])
          this.$L.alert('success', {message: '删除成功'})
          this.$refs.dataTable.refresh()
        }
        catch (e) {
          this.$L.alert('error', e.message)
        }
      }
      close()
    },
  },
  created () {
    this.getReservationConfig()
  },
  activated () {
    if (this.refresh) {
      this.$refs.dataTable.refresh()
    }
  }
}
</script>

<style scoped>

</style>
